import { currencyFloatToInteger, integerToCurrencyFloat } from '@acme/b2b/pricing';
import { GiftCardRedemption } from '@b2b/types/cart';

/**
 * Sum of all gift card redemptions on a cart, in integer cents.
 * Invalid/empty `redeemedAmount` values are treated as 0.
 */
export function getGiftCardRedemptionsTotalCents(redemptions: GiftCardRedemption[] = []): number {
  return redemptions.reduce((sum, redemption) => sum + currencyFloatToInteger(redemption.redeemedAmount || '0'), 0);
}

/**
 * Sum of all gift card redemptions on a cart, as a currency float (e.g. 15.25).
 */
export function getGiftCardRedemptionsTotal(redemptions: GiftCardRedemption[] = []): number {
  return integerToCurrencyFloat(getGiftCardRedemptionsTotalCents(redemptions));
}
